export default __webpack_public_path__ + "static/media/langer_bus_cockpit.b403a987.jpg";